import { type FC, useEffect } from "react";

import { useGetCategoriesQuery } from "~/feature/categories/categoriesApi";
import { useBackgroundError } from "~/hooks/useBackgroundError";
import { useCategories } from "~/providers/CategoriesProvider";

export const InitCategories: FC = () => {
  const { data, isLoading, error } = useGetCategoriesQuery();
  const { setCategories, setIsLoading, setIsUnavailable } = useCategories();

  useEffect(() => {
    if (data) {
      setCategories(data);
    }
  }, [data, setCategories]);

  useEffect(() => {
    setIsLoading(isLoading);
  }, [setIsLoading, isLoading]);

  useEffect(() => {
    setIsUnavailable(!!error);
  }, [setIsUnavailable, error]);

  useBackgroundError(error);

  return null;
};
